import icon from "~/components/ui/icons/svg/media-play-icon.svg";

export const MediaPlayIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="73"
      viewBox="0 0 72 73"
      fill="none"
    >
      <use xlinkHref={`#${icon}`} />
    </svg>
  );
};
